import { GenericWidget } from './generic';

export class Label extends GenericWidget {
    constructor(parameters) {
        super(parameters);
    }
}